import { Navigate } from "react-router-dom"
import { Shell } from "@/app/components/Shell"
import { RouteErrorPage } from "@/app/components/RouteErrorPage"
import { InventoryPage } from "@/app/pages/InventoryPage"
import { TransactionsPage } from "@/app/pages/TransactionsPage"
import { ORRIPage } from "@/app/pages/ORRIPage"
import { TownshipPage } from "@/app/pages/TownshipPage"
import { NewTransactionPage } from "@/app/pages/NewTransactionPage"
import { UnitsPage } from "@/app/pages/UnitsPage"
import { LeasesPage } from "@/app/pages/LeasesPage"
import { LeaseIntakePage } from "@/app/pages/LeaseIntakePage"
import { ImportPage } from "@/app/pages/ImportPage"
import { RecentUpdatesPage } from "@/app/pages/RecentUpdatesPage"
import { ProfileSettingsPage } from "@/app/pages/ProfileSettingsPage"
import { CompanySettingsPage } from "@/app/pages/CompanySettingsPage"
import { LandingPage } from "./pages/LandingPage/index"
import { clientId } from "@/app/api/client"
import { hasCapability } from "@/app/lib/capabilities"

// Where a signed-in client lands: Master Inventory when tracker is enabled,
// else the Lease Schedule for a leases-only client, else their profile settings.
const homePath = hasCapability("tracker")
  ? "/inventory"
  : hasCapability("leases")
    ? "/leases"
    : "/settings/profile"

export const routes = [
  {
    path: "/",
    errorElement: <RouteErrorPage />,
    children: [
      // Under a client slug the root IS the app — an authenticated user (the only
      // one the server lets reach the SPA here; PagesController bounces the rest to
      // login) goes straight to the client's home page (Master Inventory when the
      // tracker capability is enabled). The marketing LandingPage only renders at
      // the slug-less product root.
      {
        index: true,
        element: clientId ? <Navigate to={homePath} replace /> : <LandingPage />,
      },
      {
        element: <Shell />,
        children: [
          // Master Inventory is the app home. Old /overview links redirect here.
          { path: "overview", element: <Navigate to={homePath} replace /> },
          { path: "inventory", element: <InventoryPage /> },
          { path: "township", element: <TownshipPage /> },
          { path: "transactions", element: <TransactionsPage /> },
          { path: "recent-updates", element: <RecentUpdatesPage /> },
          { path: "orri", element: <ORRIPage /> },
          { path: "new-transaction", element: <NewTransactionPage /> },
          { path: "units", element: <UnitsPage /> },
          { path: "leases", element: <LeasesPage /> },
          // Lease intake is part of the leases module; registered only when the
          // capability is on (the API is gated server-side regardless).
          ...(hasCapability("leases")
            ? [
                { path: "leases/intake", element: <LeaseIntakePage /> },
                { path: "leases/intake/:id", element: <LeaseIntakePage /> },
              ]
            : []),
          { path: "import", element: <ImportPage /> },
          { path: "settings/profile", element: <ProfileSettingsPage /> },
          { path: "settings/company", element: <CompanySettingsPage /> },
        ],
      },
    ],
  },
]
